import { Search } from 'lucide-react';

import { Button } from '@/components/design-system';
import {
  COLOR_SCALE,
  FONT_WEIGHTS,
  GAP_SCALE,
  RADIUS_SCALE,
  SIZE_SCALE,
  MARGIN_BOTTOM,
  PADDING_Y,
} from '@/components/design-system/tokens';

interface SearchButtonProps {
  onSearch: () => void;
  t?: (namespace: string, key: string, fallback: string) => string;
}

export const SearchButton = ({ onSearch, t }: SearchButtonProps) => (
  <div className={MARGIN_BOTTOM['4']}>
    <Button
      onClick={onSearch}
      variant="tertiary"
      radius="xl"
      fullWidth
      className={`flex items-center ${GAP_SCALE['3']} ${PADDING_Y['3.5']} ${COLOR_SCALE.surface} hover:${COLOR_SCALE['surface-muted']} group`}
    >
      <span
        className={`${SIZE_SCALE.w9} ${SIZE_SCALE['9']} ${RADIUS_SCALE.lg} ${COLOR_SCALE.surface} flex items-center justify-center group-hover:scale-110 transition-transform`}
      >
        <Search className={`${SIZE_SCALE['w4.5']} ${SIZE_SCALE['4.5']} ${COLOR_SCALE.primary}`} />
      </span>
      <span
        className={`${FONT_WEIGHTS.normal} ${COLOR_SCALE.foreground} group-hover:${COLOR_SCALE.foreground}`}
      >
        {t?.('nav', 'search', 'Search')}
      </span>
    </Button>
  </div>
);
